<template>
  <div class="list" :style="{width: width, height: height + 'px'}">
    <div
      class="list-children"
      v-for="(item, index) in list"
      :key="index"
      @click="goArticleList(item)"
      :style="{'border-top': index === 0 ? '0' : '1px dashed #cccccc'}"
    >
      <div class="list-children-title">{{item.title}}</div>
      <div class="list-children-date">{{item.createdAt}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    list: Array,
    width: String,
    height: String
  },
  methods: {
    goArticleList(item) {
      this.$http
        .get(`/open/cms/category?filter=id||eq||${item.categoryId}`)
        .then(res => {
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$store.commit("eidtBreadcrumb", data.data.data[0].id);
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: "article",
                    selectMoreId: res.data.data[0].id,
                    articleId: item.id
                  }
                });
              });
          } else {
            this.$store.commit("eidtBreadcrumb", res.data.data[0].id);
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: "article",
                articleId: item.id
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  padding: 0 8px;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 1200px) {
    overflow: hidden;
  }
  &-children {
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    &:hover > &-title {
      color: #ff9240 !important;
    }
    &:hover > &-date {
      color: #ff9240 !important;
    }
    &-title {
      float: left;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 252px;
      color: #555;
    }
    &-date {
      float: right;
      font-size: 12px;
      color: #939599;
      width: 80px;
      text-align: right;
      margin-left: 10px;
    }
  }
}
</style>
